// @ts-nocheck
import React from "react";
import WifiIcon from '@mui/icons-material/Wifi';
import SinapTheme from "../../styles/SinapTheme";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { MenuDesplegable } from "./MenuDesplegable";
import { ACCESO_WIFI_PRIVADO } from "../../Contantes/Constantes";
import { PaddingLogo } from "../Home";
import keycloak from "../../Auth/Keycloak";
import { Link } from "react-router-dom";
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingBottom: '3px',
        "&:focus": {
            backgroundColor: "#aba5a3",
        }
    }
}));

export default function WifiItem({ openMenu, addMenuItemView }) {
    const classes = useStyles();
    const opciones = [
        {
            link: '/wifi/publico',
            nombre: 'UTN BA Publico',
            view: 'usuarios'
        },
        {
            link: '/wifi/invitados',
            nombre: 'UTN BA Invitados',
            view: 'usuarios'
        },
        {
            link: '/wifi/privado',
            nombre: 'UTN BA Privado',
            rol: ACCESO_WIFI_PRIVADO,
            view: 'roles'
        }
    ]

    return (
        <StyledEngineProvider >
            <ThemeProvider theme={SinapTheme}>
                <MenuDesplegable openMenu={openMenu} addMenuItemView={addMenuItemView} icon={<PaddingLogo><WifiIcon sx={{ color: 'black' }} /></PaddingLogo>} modulo={'Wifi'} opciones={opciones} />
            </ThemeProvider>
        </StyledEngineProvider >
    );
}
